import script from "./Schedule.vue?vue&type=script&setup=true&lang=ts"
export * from "./Schedule.vue?vue&type=script&setup=true&lang=ts"

import "./Schedule.vue?vue&type=style&index=0&id=554fcf3d&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554fcf3d"]])

export default __exports__